import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getUserClaims } from "../../actions/currentuser.action";
import ModalLoading from "./LoadingModal";
import { Overlay } from "components/Overlay";
import { getCurrentTransactionPeriod } from "api";
import { getAPIInstance, TokenHandler } from "api/axios.config";
import { getCurrentUser } from "services/currentUserService";
import { useOidc } from "@axa-fr/react-oidc";
import { getCurrentUserSettings } from "services/userSettingsService";
import { getCompany } from "services/companyService";
import { getApplicationSettings } from "services/applicationSettingsService";

const FreshLogin = ({ onComplete }) => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useOidc();

  const init = async () => {
    try {
      await getAPIInstance();

      await Promise.all([
        dispatch(getUserClaims()),
        getCurrentUser(),
        getCurrentUserSettings(),
        getCompany(),
        getApplicationSettings(),
        getCurrentTransactionPeriod().then((res) => {
          sessionStorage.setItem(
            "sessionPeriod",
            JSON.stringify(res?.data?.data)
          );
        }),

      ]);
    } catch (err) {
      console.error("FreshLogin failed:", err);
    } finally {
      onComplete();
    }
  };

  useEffect(() => {
    if (isAuthenticated) init();
  }, [dispatch, isAuthenticated, onComplete]);

  return (
    <>
      <ModalLoading />
      <TokenHandler/>
      <Overlay />
    </>
  );
};

export default FreshLogin;
